import { useState } from "react";
import ActionMenu from "../../../../../components/actionMenu/ActionMenu";
import { TitleCell } from "../../../../../components/tables/components/TableItem";
import { RecallSupplierReceiptListInterface } from "../../../../../redux/interfaces/recall.interface";
import { dateToString } from "../../../../../utils/dateAndTime";
import RecallReceiptInvoicesModal from "../RecallReceiptInvoicesModal";

function RecallReceiptsActionButton({
  crudData,
}: {
  crudData: RecallSupplierReceiptListInterface;
}) {
  const [showInvoicesModal, setShowInvoicesModal] = useState(false);
  const invoiceCount = crudData.invoiceDetails.length;

  if (invoiceCount <= 2) {
    return (
      <div className="!block text-left">
        <TitleCell
          title={
            invoiceCount
              ? crudData.invoiceDetails.map((invoice) => ({
                  text: `${invoice.invoiceNumber} (${
                    invoice.invoicedQuantity
                  }) - ${dateToString(invoice.invoiceDate, "-")}`,
                }))
              : "-"
          }
        />
      </div>
    );
  }

  return (
    <>
      <div className="!block text-left">
        <ActionMenu
          minItemsForMenu={2}
          ariaLabel={`Actiuni pentru receptia ${crudData.receptionFlowId}`}
          items={[
            {
              id: "invoices",
              label: `Facturi (${invoiceCount})`,
              icon: "DOCUMENTS",
              tooltip:
                "Afiseaza facturile de intrare ale receptiei, cu data si cantitatea facturata.",
              onClick: () => setShowInvoicesModal(true),
            },
          ]}
        />
      </div>
      {showInvoicesModal && (
        <RecallReceiptInvoicesModal
          receipt={crudData}
          handleClose={() => setShowInvoicesModal(false)}
        />
      )}
    </>
  );
}

export default RecallReceiptsActionButton;
